// extracted by mini-css-extract-plugin
export default {"label":"Filter_label__vEd1E","searchBox":"Filter_searchBox__-wsOO"};